import { LonLat } from '../types';

/**
 * Geocode a city/place name to [lon, lat] using the Nominatim API.
 * Returns null if the place could not be found.
 */
export async function geocodeCityName(name: string): Promise<LonLat | null> {
  const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(name)}&format=json&limit=1`;
  const res = await fetch(url, {
    headers: {
      'Accept-Language': 'en',
      'User-Agent': 'ORS-Playground/1.0',
    },
  });
  if (!res.ok) return null;
  const data = await res.json();
  if (!Array.isArray(data) || data.length === 0) return null;
  const lon = parseFloat(data[0].lon);
  const lat = parseFloat(data[0].lat);
  if (isNaN(lon) || isNaN(lat)) return null;
  return [lon, lat];
}

